import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { IMAGES } from "@/lib/constants";

const CELL_KEYS = [
  { id: "launch", accent: "text-primary",   className: "md:col-span-2 md:row-span-2" },
  { id: "supply", accent: "text-secondary" },
  { id: "lp",     accent: "text-primary" },
  { id: "team",   accent: "text-accent" },
  { id: "tax",    accent: "text-primary" },
  { id: "chain",  accent: "text-secondary", className: "md:col-span-2" },
];

export default function Tokenomics() {
  const { t } = useTranslation();
  return (
    <section id="tokenomics" data-testid="tokenomics-section" className="relative py-24 md:py-32 bg-black/40">
      <div className="absolute inset-0 -z-10 opacity-30">
        <img src={IMAGES.abstract} alt="" className="h-full w-full object-cover mix-blend-screen" />
      </div>

      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12"
        >
          <div>
            <p className="font-mono-alt text-[10px] tracking-[0.3em] text-secondary">{t("tokenomics.section_label")}</p>
            <h2 className="mt-3 font-display font-black tracking-tighter text-5xl md:text-6xl leading-[0.95]">
              {t("tokenomics.title_prefix")}<span className="text-primary">.</span>{t("tokenomics.title_suffix")}
            </h2>
          </div>
          <p className="max-w-md text-muted-foreground">{t("tokenomics.intro")}</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 auto-rows-[180px]">
          {CELL_KEYS.map((c, i) => (
            <motion.div
              key={c.id}
              data-testid={`token-cell-${c.id}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className={`glass relative rounded-sm border border-primary/25 hover:border-primary/60 p-6 flex flex-col justify-between overflow-hidden transition-colors ${c.className ?? ""}`}
            >
              <p className="font-mono-alt text-[10px] tracking-widest text-muted-foreground">{t(`tokenomics.cells.${c.id}.label`)}</p>
              <div>
                <p className={`font-display font-black tracking-tighter ${c.className?.includes("row-span-2") ? "text-5xl md:text-6xl" : "text-3xl md:text-4xl"} ${c.accent}`}>
                  {t(`tokenomics.cells.${c.id}.value`)}
                </p>
                <p className="mt-1 font-mono-alt text-xs text-muted-foreground">{t(`tokenomics.cells.${c.id}.unit`)}</p>
              </div>
              <div className="absolute -bottom-8 -right-8 h-24 w-24 rounded-full bg-primary/10 blur-2xl" />
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-8 rounded-sm border border-primary/25 bg-black/40 p-5"
          data-testid="tokenomics-note"
        >
          <p className="font-mono-alt text-[10px] tracking-widest text-secondary mb-2">{t("tokenomics.note_label")}</p>
          <p className="text-sm text-muted-foreground">{t("tokenomics.note")}</p>
        </motion.div>
      </div>
    </section>
  );
}
